import { CityRO } from '@routellers/types/dist/city/city.ro';
import { Languages } from '@routellers/types/dist/shared/enum/languages.enum';

/** Display name for admin lists: locale for UI language, else canonical title. */
export const localizedCityTitle = (
    city: Pick<CityRO, 'title' | 'locales'> | null | undefined,
    language: string | undefined,
): string => {
    if (!city) return '';

    const lang = language?.slice(0, 2).toLowerCase() === 'en' ? Languages.EN : Languages.RU;
    const fromLocale = (city.locales || [])
        .find((locale) => locale.language === lang)
        ?.title?.trim();

    return fromLocale || city.title || '';
};
